// @flow
import React from 'react';
import type { Element } from 'react';

import { uniqBy } from 'lodash';

import { IMAGE_FALLBACK_FACILITY } from '@lib/constants';

import { MapMarker } from '@components';
import { DETAILS_FACILITY } from '@routes';
import type { CompanyPlace, Photo } from './types';

export const placesToMarkers = (
  placeList: Array<CompanyPlace>,
  // t: (key: string) => string
) => (): Array<Element<any>> => {
  const getCoordinatesFromPlace = (place: CompanyPlace): string =>
    (place?.attributes?.latitude || '') + (place?.attributes?.longitude || '');

  const placeToMarker = ({
    id,
    attributes: {
      slug, name, city, country, latitude, longitude, company_slug
    },
    relationships: { photos }
  }: CompanyPlace): Element<any> => {
    const placePhoto: ?Photo = (photos?.data || []).find(img => img.attributes?.kind === 'listing');

    const placePhotoUrl: string = placePhoto?.attributes?.photo_url || IMAGE_FALLBACK_FACILITY;

    const location: ?string = `${city}, ${country}`;

    return (
      <MapMarker
        lat={parseFloat(latitude)}
        lng={parseFloat(longitude)}
        popoverContent={{
          srcImage1: placePhotoUrl,
          title: name,
          subtitle: location,
          route: {
            name: DETAILS_FACILITY,
            params: { companySlug: company_slug, slug },
            label: 'Learn More'
          }
        }}
        key={id}
      />
    );
  };

  return uniqBy(placeList, getCoordinatesFromPlace).map(placeToMarker);
};
